import React from "react";
import styles from "./styles.module.css";

const Footer = () => {
  return (
    <header className={styles.header}>
      <img className={styles.title} src={require('../../images/logo.png')} />
      <span className={styles.subtitle}> © 2025 EDENLUX CORP. All rights reserved. OTUS is a registered brand of EDENLUX CORP.<br/>
For inquiries, contact us at global@edenlx.com</span>
    </header>
  );
};

export default Footer;
